import React from 'react';
import { Segmented } from 'antd';

export default function SegmentedComponent({ options, value, setValue, block = false, size = "default" }) {
    return (
        <Segmented options={options} value={value} onChange={setValue} block={block} size={size} />
    )
}
